import React from "react";

export default function DiscountTag(props) {
    let { type, quantity, postfix } = props;

    return (
        <div className={"discount-tag-widget product-alert " + typeToColor(type)}>
            {type == 'point' ? (<p>{quantity}</p>) : (quantity)}
            <span>{postfix}</span>
        </div>
    );

    function typeToColor(type) {
        switch (type) {
            case 1:
                return "alert-yellow";
            case 2:
                return "alert-purple";
            case 3:
                return "alert-pink";
            case 'point':
                return "alert-mint";
            default:
                return "alert-yellow";
        }
    }
}
